<template>
  <!-- <div class="user"> -->
    <!-- <h3 class="headline">Deine Daten</h3> -->
    <!-- <p class="description">Die Daten benötigen wir für die Testauswertung, sie werden von uns streng vertraulich behandelt. Ohne E-Mail-Adresse können wir dir keine Testauswertung zuschicken.</p> -->

    <!-- <div class="form"> -->
      <!-- <div class="form__field">
        <label for="name">Vor- und Nachname</label>
        <input
          type="text"
          name="name"
          id="name"
          :value="name"
          @input="updateUser"
          v-validate="{required: true}">
        <span class="error" v-show="errors.has('name')">{{ errors.first('name') }}</span>
      </div> -->
      <!-- <div class="form__field">
        <label for="email">E-Mail-Adresse</label>
        <input
          type="email"
          name="email"
          id="email"
          :value="email"
          @input="updateUser"
          v-validate="{required: true, email: true}">
        <span class="error" v-show="errors.has('email')">{{ errors.first('email') }}</span>
      </div> -->
      <!-- <div class="form__field">
        <label for="gender">Geschlecht</label>
        <select
          name="gender"
          id="gender"
          @change="updateUser"
          v-validate="{required: true}">
          <option value="" checked>- Bitte auswählen -</option>
          <option value="weiblich">Weiblich</option>
          <option value="männlich">Männlich</option>
        </select>
        <span class="error" v-show="errors.has('gender')">{{ errors.first('gender') }}</span>
      </div> -->
      <!-- <div class="form__field">
        <label for="age">Alter</label>
        <input
          type="text"
          name="age"
          id="age"
          :value="age"
          @input="updateUser"
          v-validate="{required: true, numeric: true}">
        <span class="error" v-show="errors.has('age')">{{ errors.first('age') }}</span>
      </div> -->
      <!-- <div class="form__field">
        <label for="school">Schulform</label>
        <select
          name="school"
          id="school"
          @change="updateUser"
          v-validate="{required: true}">
          <option value="" checked>- Bitte auswählen -</option>
          <option value="Förderschule">Förderschule</option>
          <option value="Oberschule">Oberschule</option>
          <option value="Gesamtschule">Gesamtschule</option>
          <option value="Hauptschule">Hauptschule</option>
          <option value="Realschule">Realschule</option>
          <option value="Gymnasium">Gymnasium</option>
        </select>
        <span class="error" v-show="errors.has('school')">{{ errors.first('school') }}</span>
      </div> -->
      <!-- <div class="form__field">
        <label for="year">Jahrgangsstufe</label>
        <select
          name="year"
          id="year"
          @change="updateUser"
          v-validate="{required: true}">
          <option value="" checked>- Bitte auswählen -</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>
          <option value="13">13</option>
        </select>
        <span class="error" v-show="errors.has('year')">{{ errors.first('year') }}</span>
      </div> -->
    <!-- </div> -->

    <!-- <div class="actions"> -->
      <!-- <button @click="prevStep" class="prev" disabled>← Zurück</button> -->
      <button @click="nextStep" class="next" :disabled="user"><h1>Weiter</h1></button>
    <!-- </div> -->
  <!-- </div> -->
</template>

<script>
export default {
  name: 'UserForm',
  computed: {
    name() {
      return this.$store.state.user.name
    },
    email() {
      return this.$store.state.user.email
    },
    age() {
      return this.$store.state.user.age
    },
    user() {
      return this.$store.getters.userCompleted
    },
  },
  methods: {
    /**
     * @todo Dispatch one action instead of committing multiple mutations
     * let the action comit mutations
     */
    updateUser(e) {
      this.$store.dispatch('updateUser', e.target)
    },
    prevStep() {
      this.$store.commit('decrementStep')
    },
    nextStep() {
      this.$store.commit('incrementStep')
    },
  },
}
</script>

<style scoped>
.form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  align-items: start;
  max-width: 550px;
  margin: 0 auto;
}

.form__field {
  display: flex;
  flex-direction: column;
}

.form__field > * {
  flex: 1;
}

.form__field label {
  color: #9b9b9b;
  font-size: 0.875rem;
  text-align: left;
}

.form__field input[type='text'],
.form__field input[type='email'],
.form__field select {
  border: 1px solid #ddd;
  border-radius: 2px;
  transition: 0.2s;
  padding: 6px;
  background-color: #f0f0f0;
  font-size: 1rem;
  font-family: 'Roboto Condensed', Helvetica, Arial, sans-serif;
  height: 100%;
  appearance: none;
  outline: none;
}

.form__field input[type='text']:focus,
.form__field input[type='email']:focus,
.form__field select:focus {
  border: 1px solid #ec7404;
  background-color: white;
}

.form__field select {
  background-image: url('../assets/icon-down.svg');
  background-repeat: no-repeat;
  background-position: right 10px center;
}

.form__field .error {
  color: #bd0e23;
  font-size: 0.875rem;
  text-align: left;
  transition: 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/components/UserForm.vue